import React from 'react'
import './header.css'
import CTA from './CTA'
// import ME from '../../assets/file.png'
import ME from '../../assets/me006.jpg'
import HeaderSocials from './HeaderSocials'
const Hero = () => {
  return (
    <header>
      <div className="container header__container mt-0">
        <h5>Hello I'm</h5>
        <h1>Snehashish Patra</h1>
        <h5 className="text-light">SEO & Cloud Enthusiast</h5>
        <CTA />
        <HeaderSocials />

        <div className="me">
          <img src={ME} alt="me" />
        </div>

        <a href="#experience" className='scroll__down'>Scroll Down</a>
      </div>
    </header>
  )
}

export default Hero